export const siteTitle = 'Auckland Conventions';
export const seoAlternateName = 'Auckland Conventions, Venues & Events';
export const description = 'Auckland Conventions offers a wide variety of venues for your next function or event. Impress your guests by choosing the perfect location for your event.';
export const keywords = 'auckland conventions, functions, function centre, hire, room hire, event rooms, meeting rooms, gala dinner, cocktail events, weddings, conferences, seminars, exhibitions';

export const seoDomain = 'https://www.aucklandconventions.co.nz';

// Webpack-fingerprinted header logo only — never /static/images/… (404 on prod).
export const seoImagePath = `${seoDomain}/static/assets/images/auckland-conventions-logo.228c4cfc4a88dc384393.svg`;

export const ORGANIZATION_PHONE = '+64 9 309 2677';
export const ORGANIZATION_EMAIL = 'events@aucklandconventions.co.nz';
export const ORGANIZATION_ADDRESS = {
    '@type': 'PostalAddress',
    streetAddress: 'Level 4, Aotea Centre, 50 Mayoral Drive',
    addressLocality: 'Auckland',
    addressRegion: 'Auckland',
    postalCode: '1010',
    addressCountry: 'NZ'
};

export const PARENT_ORGANIZATION = {
    '@type': 'Organization',
    '@id': 'https://www.aucklandunlimited.com/#organization',
    name: 'Tātaki Auckland Unlimited',
    alternateName: ['Auckland Unlimited', 'TAU'],
    url: 'https://www.aucklandunlimited.com/',
    logo: {
        '@type': 'ImageObject',
        url: 'https://www.aucklandunlimited.com/static/assets/images/tataki-auckland-unlimited-a-navy-rgb.26dbb9e1deac145cabbb.svg'
    },
    sameAs: [
        'https://www.linkedin.com/company/auckland-unlimited',
        'https://www.wikidata.org/wiki/Q55764471'
    ]
};
